module.exports = __webpack_public_path__ + "static/media/low_battery_sel_f1.161c660f.svg";